// External Packages
import { BiSupport } from "react-icons/bi";
import { MdSend } from "react-icons/md";
import { useRef, useEffect, Fragment, useState } from "react";

// Internal Packages
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import LoadingSpinner from "../UI/LoadingSpinner";
import { format } from "date-fns";
import { requestAdminAPI } from "../../api/posh-api";
import { isoDateToString } from "../../util/format-date";

// Chat
export default function Chat({ selected, loadingChat, employees }) {
  //refs
  const inputRef = useRef();
  const messageContainerRef = useRef(null);

  // Initialize States
  const [loading, setLoading] = useState(false);

  // ================== SEND HANDLER ==================
  const sendHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const message = e.target.message.value;
      const response = await requestAdminAPI("send-message", {
        message: message,
        customerId: selected.id,
      });
      document.getElementById("message").value = "";
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Scroll to bottom whenever messages change or components renders
  useEffect(() => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
    selected?.messages.forEach((message) => {
      if (message.employeeId) {
        const employee = employees.find((emp) => emp.id === message.employeeId);
        message.employeeName = employee.name;
      } else message.employeeName = "POSH Bot";
    });
  }, [selected, loadingChat, employees]);

  if (loadingChat)
    return (
      <div className="h-[68vh]">
        <LoadingSpinnerWrapper />
      </div>
    );
  return (
    <div>
      <div className="flex flex-col space-y-4">
        <div className="flex flex-col justify-end h-[68vh] px-4">
          <div
            className="overflow-y-scroll no-scrollbar"
            ref={messageContainerRef}
          >
            {selected?.messages.map((message, idx) => (
              <div
                key={idx}
                className={`${
                  message.user ? "mr-auto" : "ml-auto"
                } w-fit my-4 max-w-[200px] lg:max-w-[600px]`}
              >
                <div
                  className={`${
                    message.user ? "bg-yellow-600" : "bg-stone-700 ml-auto"
                  } px-3 py-2 text-sm text-stone-200 rounded-md w-fit max-w-[600px] break-words`}
                >
                  {message.message}
                </div>
                <div className="block text-[10px] text-stone-400 text-right">
                  {message.employeeName ? `${message.employeeName} | ` : ""}
                  {format(new Date(message.time), "MM/dd/yyyy hh:mm a")}
                </div>
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={sendHandler} className="flex items-center space-x-2">
          <input
            type="text"
            name="message"
            className="w-full text-base border rounded-lg input border-primary"
            placeholder="Type your message here..."
            ref={inputRef}
            autoComplete="off"
            id="message"
          />
          {loading ? (
            <LoadingSpinner />
          ) : (
            <button type="submit">
              <MdSend className="text-3xl text-yellow-600 icon" />
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
